module.exports = __webpack_public_path__ + "images/services/onedrive-preview-logo.8eda8444574d0df36972.svg";